import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Image } from 'app/components/image';
import { breakpointTablet } from 'app/style/breakpoints';
import { spacing1, spacing2, spacing3, spacing4, spacing5 } from 'app/style/spacing';

export const StyledContainer = styled.div`
    margin-top: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing5};
    }
`;

export const StyledTitle = styled(Typography)`
    font-weight: bold;
`;

export const StyledImageContainer = styled.div`
    display: grid;
    grid-template-rows: repeat(4, auto);
    grid-template-columns: 1fr;
    grid-row-gap: ${spacing1};
    justify-content: space-between;
    justify-items: center;
    margin: ${spacing4} 0 ${spacing3};
    grid-auto-flow: column;
    text-align: center;

    @media (min-width: ${breakpointTablet}) {
        text-align: left;
        grid-column-gap: ${spacing2};
        grid-template-rows: repeat(2, auto);
        grid-template-columns: minmax(0, 246px) minmax(0, 276px);
        margin: ${spacing4} 0 ${spacing2};
    }
`;

export const StyledImage = styled(Image)`
    margin-top: ${spacing3};
    max-height: 53px;

    @media (min-width: ${breakpointTablet}) {
        margin-top: auto;
    }
`;

export const StyledConnectedMeshUnitImage = styled(Image)`
    max-height: 67px;

    @media (min-width: ${breakpointTablet}) {
        max-height: 80px;
    }
`;

export const StyledImageDescription = styled(Typography)`
    max-width: 250px;
    margin: 0 auto;

    @media (min-width: ${breakpointTablet}) {
        max-width: initial;
    }
`;
